import { createSelector } from '@ngrx/store';
import { selectSearchBoxParams } from '../router/router.selector';
import { selectDestination, selectHotels } from '../../modules/results/store/results.selector';
import { selectLoading, selectError } from '@results/store/results.selector';
import { selectContextCore } from '../context/context.selector';

export const selectInitialSearchData = createSelector(
  selectSearchBoxParams,
  selectDestination,
  selectLoading,
  selectError,
  selectHotels,
  selectContextCore,
  (params, destination, loading, error, hotels, contextCore) => {
    if (!params) {
      return undefined;
    }
    if (loading) {
      return undefined;
    }
    if (error) {
      return { ...params, origin: { id: params.entity.id, label: params.entity.name } };
    }
    if (hotels === null || hotels === undefined) {
      return undefined;
    }

    const fullName =
      destination?.city?.name && destination?.country?.name
        ? `${destination.city.name}, ${destination.country.name}`
        : contextCore?.entityName || params.entity.name;

    const countryCode =
      destination?.country?.country_code || contextCore?.entityCountryCode || null;

    return {
      ...params,
      entity: { ...params.entity, name: fullName },
      origin: {
        id: params.entity.id,
        label: fullName,
        ...(countryCode && { country_code: countryCode }),
      },
    };
  },
);
